import PropTypes from 'prop-types';

import styles from './styles.module.less';

export default function ModalBody({ width = 500, children }) {
  const modalWidth = typeof width === 'number' ? `${width}px` : width;
  return (
    <div className={styles.body} style={{ '--modal-width': modalWidth }}>
      {children}
    </div>
  );
}

ModalBody.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
};
